import { useState } from 'react';

export const useToggle = () => {
  const [expandedCards, setExpandedCards] = useState({});
  const [expandedSections, setExpandedSections] = useState({});
  const [isToggling, setIsToggling] = useState(false);

  const toggleCard = (id) => {
    if (isToggling) return;

    setIsToggling(true);
    setExpandedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
    setTimeout(() => setIsToggling(false), 300);
  };

  const toggleSection = (id, sectionType) => {
    setExpandedSections((prev) => ({
      ...prev,
      [`${id}-${sectionType}`]: !prev[`${id}-${sectionType}`],
    }));
  };
  
  // New function to ensure a section is expanded
  const expandSection = (id, sectionType) => {
    setExpandedCards((prev) => ({
      ...prev,
      [id]: true, // Make sure the card is expanded
    }));
    
    setExpandedSections((prev) => ({
      ...prev,
      [`${id}-${sectionType}`]: true, // Ensure the section is expanded
    }));
  };

  return { expandedCards, expandedSections, toggleCard, toggleSection, expandSection };
};